var exports = {
  "Nr": "PlutoniumPageLinkCard.module__card___OUpjcG",
  "Kk": "PlutoniumPageLinkCard.module__icon___OUpjcG",
  "Qq": "PlutoniumPageLinkCard.module__text___OUpjcG",
  "DD": "PlutoniumPageLinkCard.module__title___OUpjcG",
  "rf": "PlutoniumPageLinkCard.module__body___OUpjcG",
};

module.exports = exports;
